import Holidays from 'date-holidays'

import { DATE_TEMPLATES, day, format } from './extendedDayjs'

const hd = new Holidays('NO', 'nb', { types: ['public'] })

const isHolidayCache = new Map<string, boolean>()

export function isHoliday(...args: Parameters<typeof day>): boolean {
    const d = day(...args)
    const cacheKey = format(d, DATE_TEMPLATES.iso)

    const cached = isHolidayCache.get(cacheKey)
    if (cached !== undefined) {
        return cached
    }

    const result = !!hd.isHoliday(d.toDate())
    isHolidayCache.set(cacheKey, result)
    return result
}
